import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { beaconClient } from '@/lib/api/client.js';

interface WorkspaceSettings {
  companyName: string;
  signatureName: string;
  signatureTitle: string;
  signatureEmail: string;
  signaturePhone: string;
  logoUrl: string | null;
  accentColor: string;
}

export const workspaceKeys = {
  all: ['workspace'] as const,
};

export function useWorkspace() {
  return useQuery({
    queryKey: workspaceKeys.all,
    queryFn: () => beaconClient.get<WorkspaceSettings>('/api/workspace'),
    staleTime: 5 * 60_000,
  });
}

export function useUpdateWorkspace() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: Partial<WorkspaceSettings>) =>
      beaconClient.patch<WorkspaceSettings>('/api/workspace', input),
    onSuccess: (data) => {
      qc.setQueryData(workspaceKeys.all, data);
    },
  });
}
